import React, { useReducer, useRef } from 'react';
import { Rating, Placeholder } from '@thd-olt-component-react/core-ui';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { useProductReviews } from '../useProductReviews';
import { dataModel } from '../ReviewDataModel';
import { initialState } from '../../constants';
import { stateReducer } from '../../reducer';
import { RatingsAndReviewsDefaultProps, RatingsAndReviewsPropTypes } from '../RatingsAndReviewsPropTypes';
import ReviewHelper from '../Review/helpers/ReviewHelper';

import '../ratings-and-reviews.style.scss';

export const RatingsAndReviewsAccordionTitleComponent = ({
  apiKey = '', itemId, seoPageNumber, category = 'product'
}) => {
  const [state] = useReducer(stateReducer, initialState);
  const persistedStatistics = useRef({});

  const {
    averageRating, loading, statistics, totalReviews
  } = useProductReviews({ itemId, seoPageNumber, ...state });

  if (loading) {
    return (
      <Placeholder
        type="rect"
        height="50px"
        width="100%"
      />
    );
  }

  const reviewStatistics = persistedStatistics.current && persistedStatistics.current[itemId]
    ? persistedStatistics.current[itemId]
    : statistics;

  const {
    averageOverallRating,
    totalReviewCount
  } = reviewStatistics || {};

  // Use BV as primary but fallback to available product data
  const total = totalReviewCount || totalReviews;
  const totalWithCommas = ReviewHelper.numberWithCommas(total || 0);
  const average = averageOverallRating || Number(averageRating).toFixed(1);

  return (
    <div className="ratings-reviews__accordion">
      <h3 className="ratings-reviews__accordion-header">Customer Reviews</h3>
      {totalReviewCount > 0
        && (
          <div className="ratings-reviews__accordion-subheader">
            <span className="">{average} out of 5</span>
            <Rating className="reviews--no-margin" titleEnabled value={Number(average)} />
            <span className="">
              {`(${totalWithCommas})`}
            </span>
          </div>
        )}
    </div>
  );
};

RatingsAndReviewsAccordionTitleComponent.displayName = 'RatingsAndReviewsAccordionTitleComponent';
RatingsAndReviewsAccordionTitleComponent.propTypes = RatingsAndReviewsPropTypes;
RatingsAndReviewsAccordionTitleComponent.defaultProps = RatingsAndReviewsDefaultProps;
RatingsAndReviewsAccordionTitleComponent.dataModel = dataModel;

const HydratedComponent = withHydrator({
  id: 'ratings-and-reviews-accordion-title',
  scrollBuffer: 750,
  delay: 1000,
  placeholder: (
    <Placeholder
      type="rect"
      height="50px"
      width="100%"
    />
  )
}, RatingsAndReviewsAccordionTitleComponent);
const DynamicComponent = withDynamicComponent(HydratedComponent);

export const RatingsAndReviewsAccordionTitle = withLayoutGroup({
  name: 'ratings-and-reviews-accordion-title',
}, DynamicComponent);

RatingsAndReviewsAccordionTitle.displayName = 'RatingsAndReviewsAccordionTitle';
RatingsAndReviewsAccordionTitle.propTypes = RatingsAndReviewsPropTypes;
RatingsAndReviewsAccordionTitle.defaultProps = RatingsAndReviewsDefaultProps;
RatingsAndReviewsAccordionTitle.dataModel = dataModel;